import { useState } from "react";
import { brandReports, faqs, siteMeta } from "@/mocks/site";
import AboutSection from "@/pages/home/components/AboutSection";
import ArchiveSection from "@/pages/home/components/ArchiveSection";
import ContactSection from "@/pages/home/components/ContactSection";
import FaqSection from "@/pages/home/components/FaqSection";
import GuideSection from "@/pages/home/components/GuideSection";
import HeroSection from "@/pages/home/components/HeroSection";
import RadarSection from "@/pages/home/components/RadarSection";
import ScrollTop from "@/pages/home/components/ScrollTop";
import SiteFooter from "@/pages/home/components/SiteFooter";
import SiteHeader from "@/pages/home/components/SiteHeader";
import TickerBar from "@/pages/home/components/TickerBar";
import TopicSection from "@/pages/home/components/TopicSection";
import { scrollToSection } from "@/pages/home/utils";

const BASE_URL = "https://boosda.cn";

const pageDescription =
  "避雷档案是聚焦国产消费的避坑情报站，汇总黑料国产品牌、黑料国产企业与黑料国产公司的避雷记录，覆盖产品质量问题、售后纠纷、虚假宣传与营销套路，买前先查档案。";

const structuredData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      name: siteMeta.name,
      alternateName: siteMeta.slogan,
      url: `${BASE_URL}/`,
      inLanguage: "zh-CN",
      description: pageDescription,
      potentialAction: {
        "@type": "SearchAction",
        target: {
          "@type": "EntryPoint",
          urlTemplate: `${BASE_URL}/?q={search_term_string}`,
        },
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "Organization",
      name: siteMeta.name,
      url: `${BASE_URL}/`,
      email: siteMeta.email,
      description: siteMeta.intro,
    },
    {
      "@type": "WebPage",
      name: "避雷档案｜黑料国产避雷记录汇总 · 国产消费避坑情报站",
      description: pageDescription,
      url: `${BASE_URL}/`,
      inLanguage: "zh-CN",
      isPartOf: { "@type": "WebSite", url: `${BASE_URL}/` },
      about: "国产消费避雷记录与消费纠纷整理",
    },
    {
      "@type": "ItemList",
      name: "避雷档案库",
      numberOfItems: brandReports.length,
      itemListElement: brandReports.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: `${item.brandName} · ${item.categoryLabel}`,
        description: item.summary,
      })),
    },
    {
      "@type": "FAQPage",
      mainEntity: faqs.map((faq) => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.answer,
        },
      })),
    },
  ],
};

export default function Home() {
  const [keyword, setKeyword] = useState("");
  const [activeCategory, setActiveCategory] = useState("all");

  const jumpToArchive = (category: string) => {
    setActiveCategory(category);
    scrollToSection("archive");
  };

  return (
    <div className="w-full bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />

      <SiteHeader />

      <main>
        <HeroSection
          keyword={keyword}
          onKeywordChange={setKeyword}
          onSearch={() => scrollToSection("archive")}
          onPickCategory={jumpToArchive}
        />
        <TickerBar />
        <RadarSection onJumpCategory={jumpToArchive} />
        <TopicSection onSelectCategory={jumpToArchive} />
        <ArchiveSection
          keyword={keyword}
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
          onKeywordChange={setKeyword}
        />
        <GuideSection />
        <FaqSection />
        <AboutSection />
        <ContactSection />
      </main>

      <SiteFooter onJumpCategory={jumpToArchive} />
      <ScrollTop />
    </div>
  );
}